export default class HomeAnimation {
    

    toggleActive() {

        function scrollTrigger(selector){
            let els = document.querySelectorAll(selector);
            let options = {};
            els = Array.from(els);
            els.forEach(el => {
                options = {
                    threshold: el.getAttribute('animation-threshold') ? parseFloat( el.getAttribute('animation-threshold') ) : 1,
                    reverse: el.getAttribute('animation-reverse') ? true : false,
                }
                addObserver(el, options)
            })
        }

        function addObserver(el, options){
            if(!('IntersectionObserver' in window)){
                entry.target.classList.add('active')
                return
            }
            let observer = new IntersectionObserver((entries, observer) => { //this takes a callback function which receives two arguments: the elemts list and the observer instance
                entries.forEach(entry => {
                    if(entry.isIntersecting) {
                       
                        entry.target.classList.add('active')
                        
                        if(!options.reverse) {
                            observer.unobserve(entry.target);
                        }
                    }
                    else if(options.reverse) {
                        entry.target.classList.remove('active')
                    }
                })
            }, options)
            observer.observe(el)
        }


        scrollTrigger('.animation');
    }


    changeBackground() {
        function scrollTrigger(selector){
            let els = document.querySelectorAll(selector);
            let options = {};
            els = Array.from(els);
            els.forEach(el => {
                options = {
                    threshold: el.getAttribute('animation-threshold') ? parseFloat( el.getAttribute('animation-threshold') ) : 1,
                }
                addObserver(el, options)
            })
        }

        function addObserver(el, options){
            if(!('IntersectionObserver' in window)){
                el.target.style.background = el.target.getAttribute('data-color');
                return
            }
            let observer = new IntersectionObserver((entries, observer) => { //this takes a callback function which receives two arguments: the elemts list and the observer instance
                entries.forEach(entry => {
                    if(entry.isIntersecting) {
                        document.body.style.background = entry.target.getAttribute('data-color');
                    }
                    else {
                        document.body.style.background = "#050F2D";
                    }
                })
            }, options)
            observer.observe(el)
        }

        scrollTrigger('.change-bg');
    }

  
    init() {
        document.querySelector('.th-hero ') ?  $('.th-hero').addClass('active') : null;
        document.querySelector('.ta-hero ') ?  $('.ta-hero').addClass('active') : null;
        document.querySelector('.animation') ? this.toggleActive() : null;
        document.querySelector('.change-bg') ? this.changeBackground() : null;
    }
}